<i18n>
{
  "en": {
    "title": "Year in Review Sustainability Report 2017-2018",
    "description": "In 2017, Schneider Electric’s sales accelerated, boosted by the delivery of digital energy solutions and the adoption of EcoStruxure as the platform of integration and collaboration. See Schneider Electric revenue figures from 2017 and learn about key software acquisitions and product releases.",
    "companyPerformance": {
      "section": "Company Performance",
      "title": "Year in Review",
      "yearInReview": {
        "snapshot1": {
          "title": "Recognitions and awards",
          "cell1": {
            "title": "Included in CDP’s Climate A List of companies leading the fight against carbon emissions for the 7th year in a row, 2017"
          },
          "cell2": {
            "title": "1 of 104",
            "unit": "companies",
            "p1": "Featured in the first-ever Bloomberg Gender-Equality Index, January 2018"
          },
          "cell3": {
            "p1": "Received the Environmental Leader Product and Project Award for Shedd Aquarium, 2017"
          },
          "cell4": {
            "p1": "Received the Global Power Correction New Product Innovation Award from Frost &amp; Sullivan, 2017"
          },
          "cell5": {
            "title": "2nd",
            "p1": "Ranked 2nd in our industry in the Dow Jones Sustainability Index, 2017 – 2018"
          },
          "cell6": {
            "unit": "7 consecutive years",
            "p1": "Recognized as one of the world’s most ethical companies according to Ethisphere<sup>&reg;</sup> for the 8th consecutive year, 2018"
          },
          "cell7": {
            "title": "Named as one of the World’s Most Admired Companies by Fortune<sup>&reg;</sup> Magazine, 2018"
          },
          "cell8": {
            "title": "Winner in the Health and Wellbeing category of 2017 the HR Distinction Awards, 2017"
          },
          "cell9": {
            "title": "3rd",
            "p1": "Ranked 3rd on Corporate Knights Carbon Clean 200™ list, 2017"
          },
          "cell10": {
            "title": "Recognized among LinkedIn Top Companies for the second year in a row, 2017"
          },
          "cell11": {
            "p1": "Ranked as a Market Leader in Magic Quadrant for Advanced Distribution Management Systems by Gartner Research, 2017"
          },
          "cell12": {
            "title": "Voted Best Place to Work in France in the Glassdoor Employees’ Choice Awards, 2018"
          },
          "cell13": {
            "p1": "Honored with the Sustainability Award Gold Class from RobecoSAM, 2017"
          }
        },
        "table1": {
          "title": "2017 key figures",
          "row1": {
            "cell1": {
              "title": "€24.7 billion"
            },
            "cell2": {
              "p1": "in revenue"
            }
          },
          "row2": {
            "cell1": {
              "title": "€3.65 billion"
            },
            "cell2": {
              "p1": "adjusted EBITA"
            }
          },
          "row3": {
            "cell1": {
              "title": "5%"
            },
            "cell2": {
              "p1": "of revenue devoted to R&amp;D"
            }
          },
          "row4": {
            "cell1": {
              "title": "76%"
            },
            "cell2": {
              "p1": "of revenue in energy management"
            }
          },
          "row5": {
            "cell1": {
              "title": "24%"
            },
            "cell2": {
              "p1": "of revenue in industrial automation"
            }
          },
          "row6": {
            "cell1": {
              "title": "142,000"
            },
            "cell2": {
              "p1": "employees in 100 countries"
            }
          }
        },
        "snapshot2": {
          "title": "Revenue distribution to our stakeholders",
          "cell1": {
            "title": "€24,743",
            "unit": "billion",
            "p1": "2017 total revenue"
          },
          "cell2": {
            "title": "€6,212",
            "unit": "billion",
            "p1": "Employees: Wages"
          },
          "cell3": {
            "title": "€600",
            "unit": "million",
            "p1": "States: Income taxes"
          },
          "cell4": {
            "title": "€17",
            "unit": "million",
            "p1": "Non-governmental organizations: Donations"
          },
          "cell5": {
            "title": "€1,133",
            "unit": "billion",
            "p1": "Shareholders: Dividends"
          },
          "cell6": {
            "title": "€219",
            "unit": "million",
            "p1": "Banks: Net interest expenses"
          },
          "cell7": {
            "title": "€14,754",
            "unit": "billion",
            "p1": "Suppliers: Purchases and other"
          },
          "cell8": {
            "title": "€389",
            "unit": "million",
            "p1": "Net external financing<sup>*</sup> including share capital variation"
          },
          "cell9": {
            "title": "€1,808",
            "unit": "billion",
            "p1": "Operating cash flow after dividend payment"
          },
          "cell10": {
            "title": "€688",
            "unit": "million<sup>1</sup>",
            "p1": "Investments and development"
          },
          "cell11": {
            "title": "€461",
            "unit": "million<sup>2</sup>",
            "p1": "Net financial investments"
          },
          "cell12": {
            "title": "€270",
            "unit": "million",
            "p1": "Cash variation"
          },
          "cell13": {
            "title": "€1,183",
            "unit": "billion",
            "p1": "R&amp;D"
          }
        },
        "references1": {
          "1": "<sup>*</sup>Borrowings, share issues, and sale of treasury stock",
          "2": "<sup>1</sup> Including €314 million in R&amp;D",
          "3": "<sup>2</sup> Including €160 million for long-term pension plans"
        },
        "table2": {
          "title": "Company Program: 2017 performance",
          "p1": "2017 was the third and final year of our most recent company program focused on one simple idea: customer centricity. Each element of the program gave us opportunities to fulfill our customers’ needs and exceed their expectations.",
          "row1": {
            "cell1": {
              "title": "Do More"
            },
            "cell2": {
              "list1": "<strong>More Products:</strong> Product revenues up +4.3% organic in FY17, with 100+ launches in 2017",
              "list2": "<strong>More Software:</strong> Industrial software sales about flat with Q4 slightly up — transaction with AVEVA announced, providing unique software portfolio across asset life cycle for continuous and hybrid processes — good development in apps, analytics, and digital services powered by EcoStruxure",
              "list3": "<strong>More Services:</strong> High single-digit growth in FY17 orders; +6% org. growth in Q4 revenues"
            }
          },
          "row2": {
            "cell1": {
              "title": "Simplify"
            },
            "cell2": {
              "list1": "€650M Gross savings (Support Function Cost reduction and industrial productivity) in 2017 (c.€1.9B since 2015)",
              "list2": "System margin improved by c.1 pts in 2017"
            }
          },
          "row3": {
            "cell1": {
              "title": "Digitize"
            },
            "cell2": {
              "list1": "The number of connected assets increased +25% vs. 2016",
              "list2": "Unique connected customers +36% vs. 2016"
            }
          },
          "row4": {
            "cell1": {
              "title": "Innovate"
            },
            "cell2": {
              "list1": "Numerous key launches of products, advisors, and software within EcoStruxure<sup>&trade;</sup>",
              "list2": "2015 – 2017 Planet &amp; Society barometer reached 9.58/10"
            }
          },
          "row5": {
            "cell1": {
              "title": "Step Up"
            },
            "cell2": {
              "list1": "Launch of Global Family Leave policy",
              "list2": "Strong traction of the Gender Pay Equity program"
            }
          }
        },
        "table3": {
          "title": "Digital growth",
          "row1": {
            "cell1": {
              "title": "Connectivity"
            },
            "cell2": {
              "p1": "1.6 million of assets under management — up 25% year over year"
            }
          },
          "row2": {
            "cell1": {
              "title": "Experience"
            },
            "cell2": {
              "list1": "New web experience with traffic up 15% year over year",
              "list2": "New digital catalog rollout with traffic up 70%",
              "list3": "650,000+ channel partners on our digital portal"
            }
          },
          "row3": {
            "cell1": {
              "title": "Scale"
            },
            "cell2": {
              "p1": "New EcoStruxure cloud platform scaling up: ~2,500 events per second"
            }
          },
          "row4": {
            "cell1": {
              "title": "Ecosystem"
            },
            "cell2": {
              "list1": "20,000+ system integrators and developers ",
              "list2": "x2 in connected customers vs. end of 2016"
            }
          }
        },
        "tableProd": {
          "txt": {
            "title": "100+ products launched",
            "p1": "In 2017, product revenue went up 4.3 percent as we launched over 100 new innovations. This included the world’s first air circuit breaker with a built-in Class 1 power meter — the Masterpact&trade; MTZ circuit breaker —  and the Galaxy&trade; VX UPS, Compact<sup>&trade;</sup> NSXm circuit breaker, and the SM6 Connected medium-voltage switchgear."
          },
          "row1": {
            "cell1": {
              "title": "Masterpact MTZ"
            }
          },
          "row2": {
            "cell1": {
              "title": "Galaxy VX"
            }
          },
          "row3": {
            "cell1": {
              "title": "Compact NSXm"
            }
          },
          "row4": {
            "cell1": {
              "title": "SM6"
            }
          }
        },
        "txt1": {
          "title": "2017 Mergers and Acquisitions",
          "p1": "Our merger and acquisition strategy is focused on strengthening our position as the global specialist in energy management and automation. In 2017, we focused on growing our software portfolio and adding to our low-voltage expertise."
        },
        "txtmedia1": {
          "title": "IGE+XAO Group",
          "p1": "IGE+XAO is a leader in design software for electrical installations through its CAD, PLM, and simulation software. This acquisition reinforces Schneider Electric’s software offer in a field complementary to electrical distribution products and solutions."
        },
        "txtmedia2": {
          "title": "AVEVA",
          "p1": "AVEVA is a leading provider of engineering, design, and information management software to the process, plant, and marine industries. The Schneider Electric industrial software business and AVEVA have merged to trade as AVEVA Group plc, a UK listed company."
        },
        "txtmedia3": {
          "title": "ASCO Power Technologies",
          "p1": "Since 1888, ASCO Power Technologies has been an innovator in automatic transfer switches, creating world-class technology for reliable power transfer. With this acquisition, Schneider enhances its position as a leader in low-voltage innovation."
        },
        "svg1": {
          "title": "2017 revenue by geography, products, and solutions"
        },
        "svg2": {
          "title": "Revenue distribution to our stakeholders"
        }
      }
    }
  },
  "fr": {
    "title": "Year in Review Sustainability Report 2017-2018",
    "description": "In 2017, Schneider Electric’s sales accelerated, boosted by the delivery of digital energy solutions and the adoption of EcoStruxure as the platform of integration and collaboration. See Schneider Electric revenue figures from 2017 and learn about key software acquisitions and product releases.",
    "companyPerformance": {
      "section": "Performance de l’Entreprise ",
      "title": "Panorama de l’année",
      "yearInReview": {
        "snapshot1": {
          "title": "Prix et récompenses",
          "cell1": {
            "title": "Retenu pour la 7<sup>ème</sup> année consécutive parmi les 120 entreprises qui ont reçu la note « A » du CDP Climat pour leur performance en matière de lutte contre le changement climatique"
          },
          "cell2": {
            "title": "1 des 104",
            "unit": "entreprises",
            "p1": "Figurant dans le tout premier indice de performance égalité hommes-femmes publié par Bloomberg, janvier 2018"
          },
          "cell3": {
            "p1": "A reçu le prix du meilleur projet pour l’aquarium Shedd à l’occasion des <em>Environmental Leader Product and Project Awards</em>, 2017"
          },
          "cell4": {
            "p1": "S’est vu décerner par Frost & Sullivan le Prix de l’innovation Nouveau Produit pour la correction de l’alimentation énergétique mondiale, 2017"
          },
          "cell5": {
            "title": "",
            "p1": "2ème place de son secteur des indices Monde et Europe du DJSI, 2017-2018"
          },
          "cell6": {
            "unit": "",
            "p1": "Reconnu comme l'une des entreprises les plus éthiques par Ethisphere® pour la 8ème année consécutive, 2018"
          },
          "cell7": {
            "title": "Désigné comme l’une des entreprises les plus admirées au monde par Fortune<sup>®</sup> Magazine, 2018"
          },
          "cell8": {
            "title": "Gagnant dans la catégorie Santé et Bien-être de 2017, Distinction RH, 2017"
          },
          "cell9": {
            "title": "3rd",
            "p1": "Classé 3e de la « Carbon Clean 200™ list » établie par Corporate Knights, 2017"
          },
          "cell10": {
            "title": "Distingué au classement mondial Top Companies 2017 de LinkedIn pour la 2ème année consécutive"
          },
          "cell11": {
            "p1": "Classé leader du Marché dans le Magic Quadrant de Gartner Research pour ses Systèmes de Gestion de Distribution Avancés, 2017"
          },
          "cell12": {
            "title": "Élu Meilleur Employeur en France, Prix Glassdoor, 2018"
          },
          "cell13": {
            "p1": "Récompensé par le \"Sustainability Award Gold Class\" de RobecoSAM, 2017"
          }
        },
        "table1": {
          "title": "Chiffres clés 2017",
          "row1": {
            "cell1": {
              "title": "€24,7 milliards"
            },
            "cell2": {
              "p1": "de chiffre d’affaires"
            }
          },
          "row2": {
            "cell1": {
              "title": "€3,65 milliards"
            },
            "cell2": {
              "p1": "d’EBITA ajusté"
            }
          },
          "row3": {
            "cell1": {
              "title": "5%"
            },
            "cell2": {
              "p1": "du chiffre d'affaires investi en R&amp;D"
            }
          },
          "row4": {
            "cell1": {
              "title": "76%"
            },
            "cell2": {
              "p1": "du chiffre d'affaires réalisé dans la gestion de l’énergie"
            }
          },
          "row5": {
            "cell1": {
              "title": "24%"
            },
            "cell2": {
              "p1": "du chiffre d'affaires réalisé dans les automatismes industriels"
            }
          },
          "row6": {
            "cell1": {
              "title": "142 000"
            },
            "cell2": {
              "p1": "collaborateurs dans plus de 100 pays"
            }
          }
        },
        "references1": {
          "title": "",
          "1": "<sup>*</sup> Emprunts, émissions d'actions et vente d'actions propres",
          "2": "<sup>1</sup> Dont €314 millions en R&amp;D",
          "3": "<sup>2</sup> Dont 160 millions d'euros pour la retraite à long terme"
        },
        "table2": {
          "title": "Programme d'entreprise : performance 2017",
          "p1": "2017 est la troisième année de notre programme d'entreprise qui se concentre sur cinq initiatives clés pour mieux servir nos clients et nos partenaires.",
          "row1": {
            "cell1": {
              "title": "Do More"
            },
            "cell2": {
              "list1": "<strong>Plus de produits:</strong> chiffre d’affaires des produits en hausse organique de +4,3 % en 2017, marqué par plus de 100  nouveaux produits",
              "list2": "<strong>Plus de logiciels:</strong> chiffre d’affaires des logiciels industriels quasi stable, T4 en légère hausse. Annonce de l’opération avec AVEVA, offrant un portefeuille de logiciels unique sur l’ensemble du cycle de vie des actifs destinés aux processus continus et hybrides. Bon développement des applications, analytiques et services digitaux dans le cadre d’EcoStruxure.",
              "list3": "<strong>Plus de services:</strong> croissance des commandes proche de 10 % en 2017 ; +6 % du chiffre d'affaires du T4."
            }
          },
          "row2": {
            "cell1": {
              "title": "Simplify"
            },
            "cell2": {
              "list1": "Environ 650 millions d’euros de productivité brute (réduction des coûts des fonctions support et productivité industrielle) en 2017, soit environ 1,9 milliard d’euros depuis 2015.",
              "list2": "La marge des systèmes s'améliore d’environ 1 point en 2017."
            }
          },
          "row3": {
            "cell1": {
              "title": "Digitize"
            },
            "cell2": {
              "list1": "Nombre d'actifs connectés en hausse de +  24 % par rapport à 2016",
              "list2": "Nombre de clients connectés uniques  en hausse de +36 % par rapport à 2016.  "
            }
          },
          "row4": {
            "cell1": {
              "title": "Innovate"
            },
            "cell2": {
              "list1": "Nombreux lancements clés de produits, applications et logiciels au sein d’EcoStruxure.",
              "list2": "Le baromètre Planète & Société atteint la note de  9,58/10 "
            }
          },
          "row5": {
            "cell1": {
              "title": "Step Up"
            },
            "cell2": {
              "list1": "Lancement de la politique globale de congé familial",
              "list2": "Fort développement du programme équité salariale hommes/femmes "
            }
          }
        },
        "table3": {
          "title": "Croissance numérique",
          "row1": {
            "cell1": {
              "title": "Connectivité"
            },
            "cell2": {
              "p1": "1,6 million d'actifs sous gestion, en croissance de 25 % sur un an"
            }
          },
          "row2": {
            "cell1": {
              "title": "Expérience"
            },
            "cell2": {
              "list1": "Nouvelle expérience web, hausse du trafic de 15 % sur un an",
              "list2": "Déploiement du nouveau catalogue digital, hausse du trafic de 70 %",
              "list3": "Plus de 650 000 partenaires de distribution sur notre portail digital"
            }
          },
          "row3": {
            "cell1": {
              "title": "Montée en puissance"
            },
            "cell2": {
              "p1": "Montée en puissance de la toute nouvelle plateforme Cloud EcoStruxure : ~2 500 événements par seconde"
            }
          },
          "row4": {
            "cell1": {
              "title": "Écosystème"
            },
            "cell2": {
              "list1": "Plus de 20 000 intégrateurs de systèmes et développeurs à pied d’œuvre",
              "list2": "X2 le nombre de clients connectés par rapport à fin 2016"
            }
          }
        },
        "tableProd": {
          "txt": {
            "title": "Lancement de plus de 100 nouveaux produits",
            "p1": "En 2017, le chiffre d’affaires produits a augmenté de 4,3 % avec le lancement de plus de 100 innovations, dont le premier disjoncteur ouvert au monde équipé d'un système de mesure de la puissance de classe 1 (disjoncteur Masterpact MTZ), le Galaxy™ VM UPS, le disjoncteur Compact NSXm et le tableau de distribution de moyenne tension connecté SM6."
          },
          "row1": {
            "cell1": {
              "title": "Masterpact MTZ"
            }
          },
          "row2": {
            "cell1": {
              "title": "Galaxy VX"
            }
          },
          "row3": {
            "cell1": {
              "title": "Compact NSXm"
            }
          },
          "row4": {
            "cell1": {
              "title": "SM6"
            }
          }
        },
        "txt1": {
          "title": "2017 : optimisation de notre portefeuille",
          "p1": "Notre stratégie d’optimisation de notre portefeuille  repose sur le renforcement de notre position en tant que spécialiste mondial de la gestion de l’énergie et des automatismes. En 2017, nous avons mis l’accent sur l’expansion de notre portefeuille de logiciels et sur le développement de notre expertise basse tension."
        },
        "txtmedia1": {
          "title": "Groupe IGE+XAO",
          "p1": "IGE+XAO est un des acteurs leader sur le marché des logiciels d’aide à la conception et à la fabrication d’installations électriques avec son offre CAO (Conception Assistée par Ordinateur), PLM (Product Life Cycle Management) et simulation. L’opération vise à renforcer l’offre logicielle de Schneider Electric dans un domaine complémentaire à la fourniture de produits et solutions pour la distribution électrique."
        },
        "txtmedia2": {
          "title": "AVEVA",
          "p1": "AVEVA est leader dans l'édition de logiciels d’ingénierie, de conception et de gestion de l’information pour les industries maritime, manufacturière et de transformation. Schneider Electric combinera son activité de logiciels industriels à AVEVA pour former un leader dans le domaine des logiciels industriels et d’ingénierie."
        },
        "txtmedia3": {
          "title": "ASCO Power Technologies",
          "p1": "Depuis 1888, ASCO Power Technologies est un acteur innovant du domaine des commutateurs de transfert automatique (CTA), créateur de technologies de pointe pour une alimentation électrique fiable. Par cette acquisition, Schneider Electric renforce sa position de leader dans l’innovation basse tension."
        },
        "svg1": {
          "title": "Répartition du chiffre d’affaires 2017 par zone géographique et activités"
        },
        "svg2": {
          "title": "Répartition du chiffre d’affaires"
        }
      }
    }
  }
}
</i18n>
<template>
  <div id="">
    <Hero :loResSrc="require('@/assets/img/company-performance/year-in-review-lores.jpg')" :hiResSrc="require('@/assets/img/company-performance/year-in-review.jpg')" chapter="06" :section="$t('companyPerformance.section')" :title="$t('companyPerformance.title')" />

    <section class="m-b-120 m-t-120">
      <Snapshot>
        <div slot="above">
          <h2 id="recognitionandawards" v-html="$t('companyPerformance.yearInReview.snapshot1.title')" />
        </div>
        <SnapshotCard :double="true" :bgimg="require('@/assets/img/company-performance/GettyImages-585142146.jpg')" class="t-white">
          <div class="t-hr"></div>
          <h3 v-html="$t('companyPerformance.yearInReview.snapshot1.cell1.title')"></h3>
        </SnapshotCard>

        <SnapshotCard :double="true">
          <h4 class="t-green-light" v-html="$t('companyPerformance.yearInReview.snapshot1.cell2.title')"></h4>
          <p class="t-chartbody t-green-light" v-html="$t('companyPerformance.yearInReview.snapshot1.cell2.unit')"></p>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.snapshot1.cell2.p1')"></p>
        </SnapshotCard>

        <SnapshotCard>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.snapshot1.cell3.p1')"></p>
        </SnapshotCard>

        <SnapshotCard class="t-white" bgc="#626469">
          <div class="t-hr t-hr--white"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.snapshot1.cell4.p1')"></p>
        </SnapshotCard>

        <SnapshotCard class="t-white" bgc="#3dcd58">
          <div class="t-hr  t-hr--white"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.snapshot1.cell5.p1')"></p>
        </SnapshotCard>

        <SnapshotCard>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.snapshot1.cell6.p1')"></p>
        </SnapshotCard>

        <SnapshotCard class="t-white" :double="true" bgc="#3dcd58">
          <div class="t-hr t-hr--white"></div>
          <h3 class="" v-html="$t('companyPerformance.yearInReview.snapshot1.cell7.title')"></h3>
        </SnapshotCard>

        <SnapshotCard class="t-white minheight" :double="true" :bgimg="require('@/assets/img/company-performance/MoscowAlexandr.jpg')">
          <div class="t-hr"></div>
          <h3 class="" v-html="$t('companyPerformance.yearInReview.snapshot1.cell8.title')"></h3>
        </SnapshotCard>

        <SnapshotCard class="t-white" bgc="#626469">
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.snapshot1.cell9.p1')"></p>
        </SnapshotCard>

        <SnapshotCard class="t-white minheight" :double="true" :bgimg="require('@/assets/img/company-performance/Sydney0360-Edit.jpg')">
          <div class="t-hr"></div>
          <h3 class="" v-html="$t('companyPerformance.yearInReview.snapshot1.cell10.title')"></h3>
        </SnapshotCard>

        <SnapshotCard>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.snapshot1.cell11.p1')"></p>
        </SnapshotCard>

        <SnapshotCard :double="true">
          <div class="t-hr"></div>
          <h3 class="" v-html="$t('companyPerformance.yearInReview.snapshot1.cell12.title')"></h3>
        </SnapshotCard>

        <SnapshotCard class="t-white" :double="true" bgc="#3dcd58">
          <div class="t-hr t-hr--white"></div>
          <h3 v-html="$t('companyPerformance.yearInReview.snapshot1.cell13.p1')"></h3>
        </SnapshotCard>
      </Snapshot>
    </section>

    <section class="l-bg-white l-section-pad">
      <Snapshot columns="2">
        <h2 id="2017keyfigures" slot="above" v-html="$t('companyPerformance.yearInReview.table1.title')"></h2>
        <SnapshotCard class="t-white" :double="true" bgc="#3dcd58">
          <h4 class="" v-html="$t('companyPerformance.yearInReview.table1.row1.cell1.title')"></h4>
          <div class="t-hr t-hr--white"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.table1.row1.cell2.p1')"></p>
        </SnapshotCard>

        <SnapshotCard :double="true">
          <h4 class="t-green-light" v-html="$t('companyPerformance.yearInReview.table1.row2.cell1.title')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.table1.row2.cell2.p1')"></p>
        </SnapshotCard>

        <SnapshotCard class="t-white" :bgimg="require('@/assets/img/company-performance/GettyImages-697538599.jpg')">
          <h4 class="" v-html="$t('companyPerformance.yearInReview.table1.row3.cell1.title')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.table1.row3.cell2.p1')"></p>
        </SnapshotCard>

        <SnapshotCard>
          <h4 class="t-green-light" v-html="$t('companyPerformance.yearInReview.table1.row4.cell1.title')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.table1.row4.cell2.p1')"></p>
        </SnapshotCard>

        <SnapshotCard class="t-white" :bgimg="require('@/assets/img/company-performance/39298.jpg')">
          <h4 class="t-green-light" v-html="$t('companyPerformance.yearInReview.table1.row5.cell1.title')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.table1.row5.cell2.p1')"></p>
        </SnapshotCard>

        <SnapshotCard>
          <h4 class="t-green-light" v-html="$t('companyPerformance.yearInReview.table1.row6.cell1.title')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.table1.row6.cell2.p1')"></p>
        </SnapshotCard>
      </Snapshot>
    </section>

    <section class="m-t-120 m-b-120">
      <div class="l-content">
        <div class="row">
          <div class="col-xs-16 col-xs-offset-1">
            <h2 id="2017revenuebygeography" class="t-grey m-b-32" v-html="$t('companyPerformance.yearInReview.svg1.title')"></h2>
            <SvgContainer v-if="$i18n.locale === 'en'">
              <CPYearIG class="scaling-svg" />
            </SvgContainer>
            <SvgContainer v-if="$i18n.locale === 'fr'">
              <CPYearIGFR class="scaling-svg" />
            </SvgContainer>
          </div>
        </div>
      </div>
    </section>

    <section class="m-t-120 m-b-120">
      <div class="l-content">
        <div class="row">
          <div class="col-xs-16 col-xs-offset-1">
            <SvgContainer v-if="$i18n.locale === 'en'">
              <CPYearIG2 class="scaling-svg overflow-hidden" />
            </SvgContainer>
            <SvgContainer v-if="$i18n.locale === 'fr'">
              <CPYearIG2FR class="scaling-svg overflow-hidden" />
            </SvgContainer>
          </div>
        </div>
      </div>
    </section>

    <section class="m-b-60 m-t-120">
      <!-- <Snapshot>
        <div slot="above">
          <h2 class="m-b-35" v-html="$t('companyPerformance.yearInReview.snapshot2.title')" />
        </div>
        <SnapshotCard class="t-white" :double="true" bgc="#3dcd58">
          <h4 v-html="$t('companyPerformance.yearInReview.snapshot2.cell1.title')"></h4>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.snapshot2.cell1.unit')"></p>
          <div class="t-hr t-hr--white"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.snapshot2.cell1.p1')"></p>
        </SnapshotCard>

        <SnapshotCard :double="true">
          <h4 class="t-green-light" v-html="$t('companyPerformance.yearInReview.snapshot2.cell2.title')"></h4>
          <p class="t-chartbody t-green-light" v-html="$t('companyPerformance.yearInReview.snapshot2.cell2.unit')"></p>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.snapshot2.cell2.p1')"></p>
        </SnapshotCard>

        <SnapshotCard class="t-white" bgc="#626469">
          <h4 class="" v-html="$t('companyPerformance.yearInReview.snapshot2.cell3.title')"></h4>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.snapshot2.cell3.unit')"></p>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.snapshot2.cell3.p1')"></p>
        </SnapshotCard>

        <SnapshotCard>
          <h4 class="t-green-light" v-html="$t('companyPerformance.yearInReview.snapshot2.cell4.title')"></h4>
          <p class="t-chartbody t-green-light" v-html="$t('companyPerformance.yearInReview.snapshot2.cell4.unit')"></p>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.snapshot2.cell4.p1')"></p>
        </SnapshotCard>

        <SnapshotCard class="t-white" bgc="#3dcd58">
          <h4 class="" v-html="$t('companyPerformance.yearInReview.snapshot2.cell5.title')"></h4>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.snapshot2.cell5.unit')"></p>
          <div class="t-hr t-hr--white"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.snapshot2.cell5.p1')"></p>
        </SnapshotCard>

        <SnapshotCard>
          <h4 class="t-green-light" v-html="$t('companyPerformance.yearInReview.snapshot2.cell6.title')"></h4>
          <p class="t-chartbody t-green-light" v-html="$t('companyPerformance.yearInReview.snapshot2.cell6.unit')"></p>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.snapshot2.cell6.p1')"></p>
        </SnapshotCard>

        <SnapshotCard>
          <h4 class="t-green-light" v-html="$t('companyPerformance.yearInReview.snapshot2.cell7.title')"></h4>
          <p class="t-chartbody t-green-light" v-html="$t('companyPerformance.yearInReview.snapshot2.cell7.unit')"></p>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.snapshot2.cell7.p1')"></p>
        </SnapshotCard>

        <SnapshotCard class="t-white" bgc="#3dcd58">
          <h4 class="" v-html="$t('companyPerformance.yearInReview.snapshot2.cell8.title')"></h4>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.snapshot2.cell8.unit')"></p>
          <div class="t-hr t-hr--white"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.snapshot2.cell8.p1')"></p>
        </SnapshotCard>

        <SnapshotCard>
          <h4 class="t-green-light" v-html="$t('companyPerformance.yearInReview.snapshot2.cell9.title')"></h4>
          <p class="t-chartbody t-green-light" v-html="$t('companyPerformance.yearInReview.snapshot2.cell9.unit')"></p>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.snapshot2.cell9.p1')"></p>
        </SnapshotCard>

        <SnapshotCard class="t-white" bgc="#626469">
          <h4 class="" v-html="$t('companyPerformance.yearInReview.snapshot2.cell10.title')"></h4>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.snapshot2.cell10.unit')"></p>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.snapshot2.cell10.p1')"></p>
        </SnapshotCard>

        <SnapshotCard class="t-white" bgc="#3dcd58">
          <h4 class="" v-html="$t('companyPerformance.yearInReview.snapshot2.cell11.title')"></h4>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.snapshot2.cell11.unit')"></p>
          <div class="t-hr t-hr--white"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.snapshot2.cell11.p1')"></p>
        </SnapshotCard>

        <SnapshotCard>
          <h4 class="t-green-light" v-html="$t('companyPerformance.yearInReview.snapshot2.cell12.title')"></h4>
          <p class="t-chartbody t-green-light" v-html="$t('companyPerformance.yearInReview.snapshot2.cell12.unit')"></p>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.snapshot2.cell12.p1')"></p>
        </SnapshotCard>

        <SnapshotCard class="t-white" :double="true" bgc="#626469">
          <h4 class="" v-html="$t('companyPerformance.yearInReview.snapshot2.cell13.title')"></h4>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.snapshot2.cell13.unit')"></p>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.snapshot2.cell13.p1')"></p>
        </SnapshotCard>
      </Snapshot> -->
      <div class="l-content">
        <div class="row">
          <div class="col-xs-16 col-xs-offset-1">
            <h2 id="2017revenuedistrubution" class="t-grey m-b-32" v-html="$t('companyPerformance.yearInReview.svg2.title')"></h2>
            <SvgContainer v-if="$i18n.locale === 'en'">
              <RevBreakdown class="scaling-svg" />
            </SvgContainer>
            <SvgContainer v-if="$i18n.locale === 'fr'">
              <RevBreakdownFR class="scaling-svg" />
            </SvgContainer>
          </div>
        </div>
      </div>

      <References class="m-b-0">
        <Reference v-html="$t('companyPerformance.yearInReview.references1.1')"/>
        <Reference v-html="$t('companyPerformance.yearInReview.references1.2')"/>
        <Reference v-html="$t('companyPerformance.yearInReview.references1.3')"/>
      </References>
    </section>

    <section class="l-bg-white l-section-pad">
      <Table class="m-b-45" columns="2">
        <div slot="above">
          <h2 id="companyprogram" v-html="$t('companyPerformance.yearInReview.table2.title')"></h2>
          <p v-html="$t('companyPerformance.yearInReview.table2.p1')"></p>
        </div>
        <TableRow>
          <TableCell :bgimg="require('@/assets/img/company-performance/Company-Program_Do-More_clock.jpg')">
            <h4 class="t-white" v-html="$t('companyPerformance.yearInReview.table2.row1.cell1.title')"></h4>
          </TableCell>
          <TableCell>
            <ul class="t-ul--light">
              <li v-html="$t('companyPerformance.yearInReview.table2.row1.cell2.list1')"></li>
              <li v-html="$t('companyPerformance.yearInReview.table2.row1.cell2.list2')"></li>
              <li v-html="$t('companyPerformance.yearInReview.table2.row1.cell2.list3')"></li>
            </ul>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell :bgimg="require('@/assets/img/company-performance/Company-Program_Simplify_wires.jpg')">
            <h4 class="t-white" v-html="$t('companyPerformance.yearInReview.table2.row2.cell1.title')"></h4>
          </TableCell>
          <TableCell bgc="#3dcd58">
            <ul>
              <li class="t-white" v-html="$t('companyPerformance.yearInReview.table2.row2.cell2.list1')"></li>
              <li class="t-white" v-html="$t('companyPerformance.yearInReview.table2.row2.cell2.list2')"></li>
            </ul>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell :bgimg="require('@/assets/img/company-performance/Company-Program_Digitize_data.jpg')">
            <h4 class="t-white" v-html="$t('companyPerformance.yearInReview.table2.row3.cell1.title')"></h4>
          </TableCell>
          <TableCell>
            <ul>
              <li v-html="$t('companyPerformance.yearInReview.table2.row3.cell2.list1')"></li>
              <li v-html="$t('companyPerformance.yearInReview.table2.row3.cell2.list2')"></li>
            </ul>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell :bgimg="require('@/assets/img/company-performance/Company-Program_Innovate_bulb.jpg')">
            <h4 class="t-white" v-html="$t('companyPerformance.yearInReview.table2.row4.cell1.title')"></h4>
          </TableCell>
          <TableCell bgc="#3dcd58">
            <ul>
              <li class="t-white" v-html="$t('companyPerformance.yearInReview.table2.row4.cell2.list1')"></li>
              <li class="t-white" v-html="$t('companyPerformance.yearInReview.table2.row4.cell2.list2')"></li>
            </ul>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell :bgimg="require('@/assets/img/company-performance/Company-Program_Step-Up_ladder.jpg')">
            <h4 class="t-white" v-html="$t('companyPerformance.yearInReview.table2.row5.cell1.title')"></h4>
          </TableCell>
          <TableCell>
            <ul>
              <li v-html="$t('companyPerformance.yearInReview.table2.row5.cell2.list1')"></li>
              <li v-html="$t('companyPerformance.yearInReview.table2.row5.cell2.list2')"></li>
            </ul>
          </TableCell>
        </TableRow>
      </Table>

      <!-- <Txt>
        <h2 v-html="$t('companyPerformance.yearInReview.table3.title')"></h2>
      </Txt>
      <Table columns="2">
        <TableRow>
          <TableCell>
            <h3 v-html="$t('companyPerformance.yearInReview.table3.row1.cell1.title')"></h3>
          </TableCell>
          <TableCell>
            <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.table3.row1.cell2.p1')"></p>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell>
            <h3 v-html="$t('companyPerformance.yearInReview.table2.row2.cell1.title')"></h3>
          </TableCell>
          <TableCell>
            <ul>
              <li v-html="$t('companyPerformance.yearInReview.table3.row2.cell2.list1')"></li>
              <li v-html="$t('companyPerformance.yearInReview.table3.row2.cell2.list2')"></li>
              <li v-html="$t('companyPerformance.yearInReview.table3.row2.cell2.list3')"></li>
            </ul>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell>
            <h3 v-html="$t('companyPerformance.yearInReview.table3.row3.cell1.title')"></h3>
          </TableCell>
          <TableCell>
            <p class="t-chartbody" v-html="$t('companyPerformance.yearInReview.table3.row3.cell2.p1')"></p>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell>
            <h3 v-html="$t('companyPerformance.yearInReview.table3.row4.cell1.title')"></h3>
          </TableCell>
          <TableCell>
            <ul>
              <li v-html="$t('companyPerformance.yearInReview.table3.row4.cell2.list1')"></li>
              <li v-html="$t('companyPerformance.yearInReview.table3.row4.cell2.list2')"></li>
            </ul>
          </TableCell>
        </TableRow>
      </Table> -->
    </section>

    <section class="m-t-120 m-b-120">
      <FourCols>
        <div slot="above">
          <h2 id="digitalgrowth" v-html="$t('companyPerformance.yearInReview.table3.title')"></h2>
        </div>
        <FourColsItem>
          <img :src="require('@/assets/img/company-performance/GettyImages---5953293121.jpg')" alt="">
          <h3 v-html="$t('companyPerformance.yearInReview.table3.row1.cell1.title')"></h3>
          <ul class="">
            <li v-html="$t('companyPerformance.yearInReview.table3.row1.cell2.p1')"></li>
          </ul>
        </FourColsItem>

        <FourColsItem>
          <img :src="require('@/assets/img/company-performance/998-20195764_GMA-US1.jpg')" alt="">
          <h3 v-html="$t('companyPerformance.yearInReview.table3.row2.cell1.title')"></h3>
          <ul class="">
            <li v-html="$t('companyPerformance.yearInReview.table3.row2.cell2.list1')"></li>
            <li v-html="$t('companyPerformance.yearInReview.table3.row2.cell2.list2')"></li>
            <li v-html="$t('companyPerformance.yearInReview.table3.row2.cell2.list3')"></li>
          </ul>
        </FourColsItem>

        <FourColsItem>
          <img :src="require('@/assets/img/company-performance/_G9A0784.jpg')" alt="">
          <h3 v-html="$t('companyPerformance.yearInReview.table3.row3.cell1.title')"></h3>
          <ul>
            <li v-html="$t('companyPerformance.yearInReview.table3.row3.cell2.p1')"></li>
          </ul>
        </FourColsItem>

        <FourColsItem>
          <img :src="require('@/assets/img/company-performance/GettyImages-637232994_600x450.jpg')" alt="">
          <h3 v-html="$t('companyPerformance.yearInReview.table3.row4.cell1.title')"></h3>
          <ul class="">
            <li v-html="$t('companyPerformance.yearInReview.table3.row4.cell2.list1')"></li>
            <li v-html="$t('companyPerformance.yearInReview.table3.row4.cell2.list2')"></li>
          </ul>
        </FourColsItem>
      </FourCols>
    </section>

    <section class="l-bg-white l-section-pad">
      <Table columns="2">
        <div slot="above">
          <h2 id="2017productslaunched" v-html="$t('companyPerformance.yearInReview.tableProd.txt.title')"/>
          <p v-html="$t('companyPerformance.yearInReview.tableProd.txt.p1')"/>
        </div>
        <TableRow>
          <TableCell bgc="#3dcd58">
            <h3 class="t-white" v-html="$t('companyPerformance.yearInReview.tableProd.row1.cell1.title')"></h3>
          </TableCell>
          <TableCell class="no-overlay contain-img min-300" :bgimg="require('@/assets/img/company-performance/MTZ_04_edit_transp.jpg')">
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell bgc="#626469">
            <h3 class="t-white" v-html="$t('companyPerformance.yearInReview.tableProd.row2.cell1.title')"></h3>
          </TableCell>
          <TableCell class="no-overlay contain-img min-300" :bgimg="require('@/assets/img/company-performance/GVMTF225KGF_FL_HIGH_V.jpg')">
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell bgc="#3dcd58">
            <h3 class="t-white" v-html="$t('companyPerformance.yearInReview.tableProd.row3.cell1.title')"></h3>
          </TableCell>
          <TableCell class="no-overlay contain-img min-300" :bgimg="require('@/assets/img/company-performance/PB115603.jpg')">
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell bgc="#626469">
            <h3 class="t-white" v-html="$t('companyPerformance.yearInReview.tableProd.row4.cell1.title')"></h3>
          </TableCell>
          <TableCell class="no-overlay contain-img min-300" :bgimg="require('@/assets/img/company-performance/PM103194.jpg')">
          </TableCell>
        </TableRow>
      </Table>
    </section>

    <section class="m-b-120 m-t-120">
      <div class="l-content">
        <div class="row">
          <div class="col-xs-14 col-xs-offset-2">
            <div class="m-b-80">
              <h2 id="2017mergersandaquisitions" class="t-grey m-b-28" v-html="$t('companyPerformance.yearInReview.txt1.title')"></h2>
              <p v-html="$t('companyPerformance.yearInReview.txt1.p1')"></p>
            </div>
          </div>
        </div>
      </div>

      <TxtMedia class="m-b-50">
        <h3 slot="main-content" v-html="$t('companyPerformance.yearInReview.txtmedia1.title')"/>
        <p slot="main-content" v-html="$t('companyPerformance.yearInReview.txtmedia1.p1')" />
        <img class="mw-320" slot="sidebar" src="@/assets/img/company-performance/ige-xao-logo.png" />
      </TxtMedia>

      <TxtMedia class="m-b-50">
        <h3 slot="main-content" v-html="$t('companyPerformance.yearInReview.txtmedia2.title')"/>
        <p slot="main-content" v-html="$t('companyPerformance.yearInReview.txtmedia2.p1')" />
        <img class="mw-320" slot="sidebar" src="@/assets/img/company-performance/aveva-logo.png" />
      </TxtMedia>

      <TxtMedia class="">
        <h3 slot="main-content" v-html="$t('companyPerformance.yearInReview.txtmedia3.title')"/>
        <p slot="main-content" v-html="$t('companyPerformance.yearInReview.txtmedia3.p1')" />
        <img class="mw-320" slot="sidebar" src="@/assets/img/company-performance/asco.png" />
      </TxtMedia>
    </section>

   <div class="l-content">
      <FooterNav
        nextRoute="CompanyPerformance_20152017PlanetSocietyBarometer"
        prevRoute="CompanyPerformance_Overview" />
    </div>

  </div>
</template>

<script>
import FooterNav from '@/components/FooterNav'
import Hero from '@/components/Hero'
import Quote from '@/components/Quote'
import Statement from '@/components/Statement'
import FourCols from '@/components/FourCols'
import FourColsItem from '@/components/FourColsItem'
import CTA from '@/components/CTA'
import Txt from '@/components/Txt'
import References from '@/components/References'
import Reference from '@/components/Reference'
import YouTubeVideo from '@/components/YouTubeVideo'
import Snapshot from '@/components/Snapshot'
import SnapshotCard from '@/components/SnapshotCard'
import Table from '@/components/Table'
import TableRow from '@/components/TableRow'
import TableCell from '@/components/TableCell'
import Pillar from '@/components/Pillar'
import TxtMedia from '@/components/TxtMedia'
import SvgContainer from '@/components/SvgContainer'

import DoMoreSVG from '@/assets/img/company-performance/do-more.svg'
import DigitizeSVG from '@/assets/img/company-performance/digitize.svg'
import InnovateSVG from '@/assets/img/company-performance/innovate.svg'
import SimplifySVG from '@/assets/img/company-performance/simplify.svg'
import StepUpSVG from '@/assets/img/company-performance/step-up.svg'
import CPYearIG from '@/assets/img/ig/company-performance-year-review-2017.svg'
import CPYearIGFR from '@/assets/img/ig/company-performance-year-review-2017_fr.svg'
import CPYearIG2 from '@/assets/img/ig/company-performance-year-review-business.svg'
import CPYearIG2FR from '@/assets/img/ig/company-performance-year-review-business_fr.svg'
import RevBreakdown from '@/assets/img/ig/year-review-revenue-breakdown.svg'
import RevBreakdownFR from '@/assets/img/ig/company-performance-year-review-revenue_fr.svg'

export default {
  name: 'CompanyPerformance_YearInReview',
  metaInfo () {
    return {
      title: this.$t('title'),
      meta: [
        { name: 'description', content: this.$t('description') }
      ]
    }
  },
  mounted () {
    if (window.location.hash.substr(1).length > 0) {
      this.$nextTick(function () {
        document.getElementById(window.location.hash.substr(1)).scrollIntoView()
      })
    }
  },
  components: {
    FooterNav,
    Hero,
    Quote,
    Statement,
    FourCols,
    FourColsItem,
    CTA,
    Txt,
    References,
    Reference,
    YouTubeVideo,
    Snapshot,
    SnapshotCard,
    Table,
    TableRow,
    TableCell,
    DoMoreSVG,
    DigitizeSVG,
    InnovateSVG,
    SimplifySVG,
    StepUpSVG,
    Pillar,
    TxtMedia,
    SvgContainer,
    CPYearIG,
    CPYearIGFR,
    CPYearIG2,
    CPYearIG2FR,
    RevBreakdown,
    RevBreakdownFR
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/company-performance/year-in-review.vue